import { matchPath } from 'react-router-dom';
import { employeeAuthenticatedNavigationConfig } from '../components/navigation/authenticatedRoutes/employee/employeeAuthenticatedNavigationConfig';
import { officialAuthenticatedNavigationConfig } from '../components/navigation/authenticatedRoutes/official/officialAuthenticatedNavigationConfig';
import { Employee } from '../models/Employee';
import { AccessLevel } from '../types/AccessLevel';

const matchesAnyRoute = (url: string, routePaths: string[]): boolean => {
  return routePaths.some((path) => matchPath({ path, end: true }, url) !== null);
};

export const userHasAccessToView = (url: string, user: Employee) => {
  if (user.accessLevel === AccessLevel.SuperUser) {
    return true;
  } else if (user.accessLevel === AccessLevel.Cleaner) {
    const allCleanersPaths = employeeAuthenticatedNavigationConfig.map((e) => e.path);

    return matchesAnyRoute(url, allCleanersPaths);
  } else if (user.accessLevel === AccessLevel.Admin) {
    const allCleanersPaths = employeeAuthenticatedNavigationConfig.map((e) => e.path);
    const allOfficialPaths = officialAuthenticatedNavigationConfig.map((e) => e.path);

    return matchesAnyRoute(url, allCleanersPaths) || matchesAnyRoute(url, allOfficialPaths);
  } else {
    return false;
  }
};
